import api from './client';

export async function linkTeamsAccount(token: string) {
  const { data } = await api.post('/teams/link-account', {
    teamsToken: token,
  });

  return data;
}
